import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

const resolvedApiKey =
  process.env.REACT_APP_FIREBASE_API_KEY ||
  process.env.REACT_APP_FIREBASE_WEB_API_KEY ||
  "AIzaSyCgzBU1G1pn76axbav63xuRnjhPkLGxqNs";

const firebaseConfig = {
  apiKey: String(resolvedApiKey || "").trim(),
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "findmylawyer-1cea7.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "findmylawyer-1cea7",
  storageBucket:
    process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "findmylawyer-1cea7.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "585419232789",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:585419232789:web:3eb6e0400c076e12a2e01c",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({ prompt: "select_account" });
